import type { CourseStatus } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

export type CourseDescriptionParams = {
  courseId: number;
  queryParams?: {
    status?: CourseStatus;
  };
};

const { useGet: useCourseDescription } = getCRUDHooks({
  entityName: 'courseDescription',
  get: ({ courseId, queryParams = {} }: CourseDescriptionParams) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.courses.getIntroduction(courseId, false, queryParams),
});

export default useCourseDescription;
